exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-send-button[data-v-34751fc9]{width:80px}.isOnlyContentWrapper[data-v-34751fc9]{padding:0 15px;box-sizing:border-box}.attachedPdf[data-v-34751fc9]{width:100px!important}.attachedPdfFlgShared[data-v-34751fc9]{right:42px!important}", ""]);

// exports
